module.exports = __webpack_public_path__ + "img/img_overdue.23dc61d3.png";